<template>
    <div>

        <config-main-title>
            Frases Padrão
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="form-row mb-2">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search fa-fw" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Frase
                    </button>
                </div>
            </div>

            <div class="form-row mb-3">
                <div class="col col-12 col-md-6">
                    <az-input icon="fas fa-user-md fa-fw" 
                        type="autocomplete" 
                        optionsMode="aql"
                        service="medicos.index"
                        optionsName="medicos-frases"
                        optionsData="id_pessoa"
                        placeholder="Todos os Profissionais..."
                        :optionsParm="{ ativos: true }"
                        v-model="filtros.id_medico"
                        @input="limparSeVazio(filtros.id_medico)"
                        @selecionado="load()">
                        <template v-slot:buttonposb>
                            <div class="input-group-append">
                                <button type="button" class="btn btn-outline-primary" title="Incluir Profissionais" @click="incluir_medico_bloco()">
                                    <i class="fa-solid fa-user-plus"></i>
                                </button>
                                <button type="button" class="btn btn-outline-danger" title="Incluir Profissionais" @click="remover_medico_bloco()">
                                    <i class="fa-solid fa-user-minus"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-6">
                    <az-input
                        placeholder="Todos os procedimento..."
                        icon="fas fa-play fa-fw"
                        type="autocomplete"
                        service="procedimentos.index"
                        optionsMode="aql"
                        optionsName="procedimentos.index"
                        optionsData="id_procedimento"
                        v-model="filtros.id_procedimento"
                        @input="limparSeVazio(filtros.id_procedimento)"
                        @selecionado="load()" />
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum Texto Padrão identificado.'" 
                icon="fas fa-search"
                :action="'Incluir Frase'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <span v-if="dado.fl_recorrente" class="text-muted"
                            data-toggle="tooltip" data-placement="top" title="Recorrente"> 
                            <i class="fas fa-sync"></i>
                        </span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div class="d-flex" v-else>
                            <div v-if="dado.js_classes" class="mr-3">
                                <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                    v-for="(tag, itx) in dado.js_classes" :key="itx">
                                    <span class="badge badge-success ml-1">
                                        {{ tag }}
                                    </span>
                                </a>
                            </div>

                            <button type="button" class="btn btn-outline-primary btn-sm mr-2" 
                                data-toggle="tooltip" data-placement="top" title="Profissionais Habilitados"
                                @click="medico_lista(dado)">
                                <i class="fas fa-user-md"></i>
                                <span class="badge badge-primary ml-2" v-if="dado.medico_lista && dado.medico_lista.length">
                                    {{ dado.medico_lista.length }}
                                </span>
                            </button>

                            <button type="button" class="btn btn-outline-primary btn-sm mr-2" 
                                data-toggle="tooltip" data-placement="top" title="Procedimentos Habilitados"
                                @click="procedimento_lista(dado)">
                                <i class="fa fa-play"></i>
                                <span class="badge badge-primary ml-2" v-if="dado.procedimento_lista && dado.procedimento_lista.length">
                                    {{ dado.procedimento_lista.length }}
                                </span>
                            </button>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_texto_padrao ? '' : 'Nova' }}
                            Frase Padrão
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12 col-md-10">
                                <az-input
                                    placeholder="Informe o título do texto..."
                                    label="Tïtulo"
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    placeholder="Atalho..."
                                    label="Tïtulo"
                                    :validate="validate"
                                    required
                                    v-model="item.st_atalho" />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col col-12">
                                <small class="text-muted">Texto Padrão</small>
                                <az-editor v-model="item.st_texto" editorStyle="height: 320px" />
                            </div>
                        </div>

                        <az-sub-title class="mt-1" title="Classificação" />
                        <multiselect
                            v-model="item.js_classes"
                            :options="options_classes"
                            :multiple="true"
                            :taggable="true"
                            @tag="addTag"
                            placeholder="Selecione uma classificação..."
                            selectLabel="Pressione [ENTER] para selecionar"
                            deselectLabel="Pressione [ENTER] para remover"
                            tagPlaceholder="Pressione [ENTER] para incluir"
                            selectedLabel="Selecionado">
                            <template slot="noOptions">
                                Nenhuma classificação criada.
                            </template>
                        </multiselect>

                        <div class="row mt-3">
                            <div class="col col-12">
                                <az-input   
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Filtrar Textos por Campos (id's)"
                                    v-model="item.fl_filtrar_campos" />
                            </div>
                        </div>

                        <template v-if="item.fl_filtrar_campos">
                            <az-sub-title class="mt-1" title="Id's dos Campos Relacionados" />
                            <multiselect
                                v-model="item.js_lista_ids"
                                :options="[]"
                                :multiple="true"
                                :taggable="true"
                                @tag="addTagId"
                                placeholder="Informe um Id..."
                                selectLabel="Pressione [ENTER] para selecionar"
                                deselectLabel="Pressione [ENTER] para remover"
                                tagPlaceholder="Pressione [ENTER] para incluir"
                                selectedLabel="Selecionado">
                                <template slot="noOptions">
                                    Nenhuma Id relacionado.
                                </template>
                            </multiselect>
                        </template>
                        
                        <pre v-if="1==0">{{ item }}</pre>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="tetoAtendimento" :id="item.id_texto_padrao" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_texto_padrao ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <medico-lista ref="medicolista" @refresh="load()" :agenda_compartilhada="true" />
        <procedimento-lista ref="proclista" @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEditor from '../../shared/forms/AzEditor.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import MedicoLista from '../../shared/MedicoLista.vue';
import ProcedimentoLista from '../../shared/ProcedimentoLista.vue';
import Multiselect from 'vue-multiselect';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            filtros: { 
                id_medico: "",
                id_procedimento: "", 
            },
            options_classes: [], 
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        MedicoLista,
        ProcedimentoLista,
        AzEditor,
        Multiselect,
        AzSubTitle
    },

    computed: { 
        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

    },

    methods: { 
        addTagId (newTag) {
            if ( !this.item.js_lista_ids )
                this.item.js_lista_ids = [];

            this.item.js_lista_ids.push(newTag);
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        incluir_medico_bloco () { 
            this.$refs.medicolista.abrir('textoPadrao', this.lista.map(item => item.id_texto_padrao));
        },

        remover_medico_bloco () { 
            this.$refs.medicolista.abrir('textoPadrao', this.lista.map(item => item.id_texto_padrao), true);
        },

        limparSeVazio (id) { 
            if ( !id ) { 
                this.load();
            }
        },

        medico_lista (item) { 
            this.$refs.medicolista.abrir('textoPadrao', item.id_texto_padrao);
        },

        procedimento_lista (item) { 
            this.$refs.proclista.abrir('textoPadrao', item.id_texto_padrao);
        },

        incluir () { 
            this.validate = false;

            let item = {
                id_texto_padrao: null, 
                st_titulo: "",
                st_texto: "", 
                st_atalho: "",
                fl_ativo: true, 
            };

            this.editar (item);
        },

        load () { 
            this.$util.load(this, { 
                service: 'textos_padrao',
                with: ['medico_lista.medico', 'procedimento_lista.procedimento'],
                parms: { 
                    cadastro: true, 
                    ...this.filtros
                },
            });
        },

        editar (item) {
            if ( this.$store.state.loading ) { 
                this.$toast.add({ 
                    severity: 'info',
                    summary: 'Aguarde',
                    detail: 'Atualização em andamento... Tente novamente...',
                    life: 3000,
                });

                return;
            }
            
            this.validate = false;
            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },
        atualizar () { 

            this.$util.atualizar(this, { 
                service: 'textos_padrao',
                func: 'store',
                dados: this.item,
                modal: 'edicaoModal',
                reload: true, 
            });

        },
        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$store.commit('loading', true);

            let query = { q: [ 
                { 
                    name: 'textos_padrao.toggle',
                    id: 'toggle',
                    parms: { 
                        ...item,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.toggle.status == 200 ) { 
                        //
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Texto Padrão", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.loadItem(this, {
            service: 'textos_padrao',
            func: 'tags',
        })
        .then(res => {
            this.options_classes = res;
        });

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>